import GroupedHeader from '../../../../../../pages/vip/views/real-estate/sections/grouped-header';

export default GroupedHeader;
